import styled from "styled-components";

export const CardWrapper = styled.div`
    ${(props) => props.isUploading && `
    & > div {
      border-color: ${props.theme.colors.dividerGray};
      pointer-events: none;
      
      &:hover {
        transform: none;
        box-shadow: none;
        border-color: ${props.theme.colors.dividerGray};
      }
    }
  `}
`;

export const MainContainer = styled.div`
    width: 100%;
    height: 238px;
    display: flex;
    flex-direction: column;
    pointer-events: ${(props) => (props.isUploading ? 'none' : 'auto')};
    position: relative;
`;

export const HeaderContainer = styled.div`
    width: 100%;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 4px;
    
    /* Control de visibilidad del checkbox */
    & > div.document-checkbox {
        visibility: ${(props) => props.isCheckboxVisible ? 'visible' : 'hidden'};
    }
`;

export const TitleContainer = styled.div`
    width: 100%;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 12px;
    opacity: ${(props) => (props.isUploading ? '0.5' : '1')};

    ${(props) => props.isUploading && `
    color: ${props.theme.colors.silverGrayTwo};
    
    svg, span, p {
      color: ${props.theme.colors.silverGrayTwo};
    }
  `}
`;

export const OwnerContainer = styled.div`
    width: 100%;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: ${(props) => props.theme.colors.davysGrey};
    opacity: ${(props) => (props.isUploading ? '0.5' : '1')};
    margin-top: 4px;

    ${(props) => props.isUploading && `
    svg, span, p {
      color: ${props.theme.colors.silverGrayTwo};
    }
  `}
`;

export const OwnerLeftContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;
`;

export const CanEditContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
`;

export const LastOpenedContainer = styled.div`
    width: 100%;
    height: 20px;
    display: ${(props) => (props.isUploading ? 'none' : 'flex')};
    align-items: center;
    justify-content: space-between;
    color: ${(props) => props.theme.colors.davysGrey};
    margin-bottom: 12px;
`;

export const LastOpenedLeftContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;
`;

export const StarredContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
`;

export const TagsContainer = styled.div`
    width: 100%;
    min-height: 40px;
    margin-bottom: 12px;
    display: flex;
    align-items: ${(props) => (props.isColumn ? 'flex-start' : 'center')};
    justify-content: flex-start;
    flex-direction: ${(props) => (props.isColumn ? 'column' : 'row')};
    flex-wrap: ${(props) => (props.isColumn ? 'nowrap' : 'wrap')};
    gap: 4px;
    overflow: hidden;
`;

export const UploadStatusTags = styled.div`
    display: ${(props) => (props.isUploading ? 'flex' : 'none')};
    flex-direction: column;
    gap: 4px;
`;

export const NormalTags = styled.div`
    display: ${(props) => (props.isUploading ? 'none' : 'flex')};
    flex-wrap: wrap;
    gap: 4px;
`;

export const Divider = styled.div`
    width: 100%;
    height: 1px;
    background-color: ${(props) => props.theme.colors.highClearGray};
    display: ${(props) => (props.isUploading ? 'none' : 'block')};
`;

export const ContextualTagsContainer = styled.div`
    flex: 1;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;
    
    /* Ocultar tags contextuales por defecto, mostrar en hover o cuando está checked */
    & .contextual-tags-wrapper {
        visibility: ${(props) => props.isChecked ? 'visible' : 'hidden'};
    }
    
    /* Mostrar en hover del MainContainer padre */
    ${MainContainer}:hover & .contextual-tags-wrapper {
        visibility: ${(props) => !props.isUploading ? 'visible' : 'hidden'};
    }
`;

export const ContextualTagsWrapper = styled.div`
    display: flex;
    gap: 4px;
`;
